export const ALLOWED_EMAILS = [
  "dolores.csabai@gmail.com",
  "imranrautan@gmail.com",
  "adrianjgt@gmail.com",
];

export const EMAIL_TO_USER = {
  "dolores.csabai@gmail.com": "Dolores",
  "imranrautan@gmail.com": "Imran",
  "adrianjgt@gmail.com": "Adrian",
};

export const USERS = ["Imran", "Adrian", "Dolores"];

export const USER_COLORS = {
  Imran: "#7a5c2e",
  Adrian: "#3d6b8a",
  Dolores: "#8a3d6b",
};

export const USER_INITIALS = {
  Imran: "I",
  Adrian: "A",
  Dolores: "D",
};

// Activities
export const ACT_LOCATIONS = ["Home", "Budapest", "Litvill 1", "Litvill 2", "Gym", "Other"];
export const WORK_SUBS = ["House", "Garden", "Litvill 1", "Litvill 2"];
export const EXERCISE_SUBS = ["Yoga", "Step", "Walking", "Cycling", "Swim", "Other"];

// Inventory
export const INV_PLACES = ["Main house", "Litvill 1", "Litvill 2", "Storage unit", "Car", "Other"];
export const INV_CATS = ["tools", "electronics", "kitchen", "garden", "clothing", "docs", "furniture", "food", "other"];

// Budget
export const BUD_CATS = ["food", "transport", "tools", "repairs", "subscriptions", "utilities", "health", "garden", "other"];
export const CURRENCIES = ["EUR", "HUF", "USD", "GBP"];
export const PAY_METHODS = ["Cash", "Card", "Transfer", "Other"];